module.exports = __webpack_public_path__ + "img/logo_text.6415a6c9.png";